/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { View } from 'backbone.marionette';

// import fileUploadConfig from '@/fileupload/fileUploadConfig';
import FileUploadModel from '@/fileupload/FileUploadModel';
// import FileTemplateDownloadTmpl from '@/fileupload/FileTemplateDownloadTmpl.hbs';

import FileUploadView from '../FileUploadView';

import tmplAttachmentItemView from './AttachmentItemView.hbs';

const AttachmentItemView = View.extend({
  template: tmplAttachmentItemView,

  className: 'attachment-item-view',

  ui: {
    label: '.label',
    attachment: '.attachment'
  },

  regions: {
    label: '@ui.label',
    attachment: '@ui.attachment'
  },

  childViewEvents: {
    'file:deleted': 'onFileDelete',
    'upload:complete': 'onFileUpload'


  },

  // childViewTriggers: {
  //   'upload:complete': 'upload:complete'
  // },

  initialize(options) {
    this.isReadOnly = this.model.get('isReadOnly');
    // The label here can be a downloadable document template or just a string (default)
    const label = this.model.get('label');
    const attachment = this.model.get('attachment');
    
    this.initializeLabel(label);
    this.initializeAttachment(attachment);
  },

  initializeLabel(label) {
    if (!label?.isDocument || label?.isHidden) {
      return;
    }

    let collection;

    if (label.attachmentId) {
      const fileUploadModel = new FileUploadModel({
        guid: label.attachmentId,
        fileName: label.fileName,
        label: label.text,
        hideFileIcon: true,
        alignRight: true,
        isReadOnly: this.isReadOnly,
        attachmentId: label.attachmentId,
        downloadType: label.downloadType
      });
      collection = new Backbone.Collection([fileUploadModel]);

    }


    this.labelFileUploadView = new FileUploadView({
      isReadOnly: this.isReadOnly,
      isRequired: this.model.get('isRequired'),
      displayAsterisk: this.model.get('isRequired'),
      allowMultipleFiles: false,
      uploadClass: 'btn btn-outline-primary btn-sm',
      // downloadXml: FileTemplateDownloadTmpl,
      collection
    });
  },

  initializeAttachment(attachment) {
    const {
      attachmentId = null,
      defaultFileName = null,
      attachmentName = null,
      fileUploadTmpl = null,
      pathToFileId = null,
      validator = null,
      metadata = {}
    } = attachment;
    let fileUploadModel;
    let collection;

    if (attachmentId) {
      fileUploadModel = new FileUploadModel({
        fileId: attachmentId,
        attachmentId,
        fileName: attachmentName,
        isReadOnly: this.isReadOnly
      });
      collection = new Backbone.Collection([fileUploadModel]);
    }

    this.fileUploadView = new FileUploadView({
      isReadOnly: this.isReadOnly,
      allowMultipleFiles: false,
      uploadXml: fileUploadTmpl,
      defaultFileName,
      validator,
      pathToFileId,
      metadata: { fileId: attachmentId, ...metadata },
      collection
    });
  },

  onRender() {
    if (this.model.get('label')?.isDocument) {
      this.showChildView('label', this.labelFileUploadView);
    }
    this.showChildView('attachment', this.fileUploadView);
  },

  onFileDelete() {
    this.model.attributes.attachment.attachmentId = null
    this.model.attributes.attachment.attachmentName = null
    this.trigger('file:deleted', this.model);
  },

  onFileUpload(attachmentId) {
    this.model.attributes.attachment.attachmentId = attachmentId
    this.trigger('upload:complete', this.model);
  },

  validate() {
    return !this.model.get('isRequired') || !!this.fileUploadView.collection.length > 0;
  }
});

export default AttachmentItemView;
